import React, {useState, useEffect} from 'react'
import Header from 'components/Headers/Header';
import {
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    Container,
    CardText,
    Button,
    Row,
    Col,
    Badge,
    CardImg,
    CardImgOverlay,
    TabContent, TabPane, Nav, NavItem, NavLink, 
    FormGroup,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Form
} from "reactstrap";
import AddDatCourseModal from 'components/Modal/AddDatCourseModal';
import Paginate from 'components/Pagination/DatCoursesPagination';
import TotalCourses from 'components/Widgets/DatCourses/TotalCourses';
import { fetchPaymentRecord } from 'redux/Payments/PaymentsActions';
import ManageCourseItem from 'components/Courses/ManageCourseItem';
import { connect, useDispatch } from 'react-redux';
import { fetchDatCourses, deleteDatCourse, deleteDatCourseReset, createDatBundleCourses, createDatBundleCoursesReset, fetchDatBundleCourses} from 'redux/ManageDatCourses/ManageDatCoursesActions'
import Swal from 'sweetalert2'
import ManageDatCoursesLessons from './ManageDatCoursesLessons';
const ManageDatCourses = (props) => {
    const dispatch = useDispatch()

    const addZeroes = num => num.toLocaleString("en",{minimumFractionDigits: 2})

    const [datCoursesSale,setDatCoursesSale] = useState(0);
    const [paidUsers,setPaidUsers] = useState([]);
    const [bundleCourses, setBundleCourses] = useState([]);

    useEffect(() => {
        dispatch(fetchPaymentRecord({table: 'datCourses'}))
        dispatch(fetchDatBundleCourses())

    }, []);

    useEffect(() => {
        if(props.fetchDatBundleCourses.bundlecourses.length){
           setBundleCourses(props.fetchDatBundleCourses.bundlecourses)
        }
    }, [props.fetchDatBundleCourses])

    useEffect(() => {
        if(props.fetchPaymentRecord.fetchpaymentrecord.length){
            let purchased = 0
            let users = []
            props.fetchPaymentRecord.fetchpaymentrecord[0].map((p)=>{
                return (
                    users.push(p.userHandle),
                    purchased += p.amount
                ) 
            })
            // console.log(users)
            setPaidUsers(users)
            setDatCoursesSale(addZeroes(purchased))
        }
    }, [props.fetchPaymentRecord ])
    

    const [currentPage, setCurrentPage] = useState(1);
	const [coursesPerPage] = useState(6);

    const [modalAddDatCourseModal, setModalAddDatCourseModal] = useState(false);
    const [datCoursesLists, setDatCoursesLists] = useState([]);

    const [courseLists, setCoursesLists] = useState([]);

    const indexOfLastPost = currentPage * coursesPerPage;
	const indexOfFirstPost = indexOfLastPost - coursesPerPage;
	const currentCourses = datCoursesLists.slice(indexOfFirstPost, indexOfLastPost);

	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const previousPage = () => {
		if (currentPage !== 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const nextPage = () => {
		if (currentPage !== Math.ceil(datCoursesLists.length / coursesPerPage)) {
			setCurrentPage(currentPage + 1);
		}
	};

    const [editCourse, setEditCourse] = useState(false);
   
    
    const toggleAddDatCourseModal = () =>{
        setEditCourse(false)
        setModalAddDatCourseModal(!modalAddDatCourseModal);
        
    } 


    useEffect(() => {
        
        dispatch(fetchDatCourses({}))

    },[props.createDatCourse, props.updateDatCourse, props.deleteDatCourse], [])

    
    useEffect(() => {
        
        
        if(props.fetchDatCourses.datcourses.length){
            

            setDatCoursesLists(props.fetchDatCourses.datcourses)
            setCoursesLists(props.fetchDatCourses.datcourses)
        }
        else{
            setDatCoursesLists([])
            setCoursesLists([])
        }
        

    }, [props.fetchDatCourses ])
    

    const handleEditDetails = (index) => {
        console.log(index)
        setModalAddDatCourseModal(!modalAddDatCourseModal);
        setEditCourse(index)
        
    }

    const handleDeleteDetails = (datCourseId) => {
        
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                dispatch(deleteDatCourse({datCourseId : datCourseId}))
        
            }
        })

    }

    useEffect(() => {
    
        
        if(props.deleteDatCourse.datcourses.length && typeof props.deleteDatCourse.error === "undefined"){
          
          Swal.fire({
              title: 'Success!',
              text: 'Successfully deleted DAT course!',
              icon : 'success',
              timer: 3000
              
            }
          ).then((result) => {
            dispatch(deleteDatCourseReset());
            
          })
          
        }
      
        else if(typeof props.deleteDatCourse.error !== "undefined"){
       
          Swal.fire({
              title:'Failed!',
              text:'Failed to delete DAT course!',
              icon :'error',
              timer: 3000
              
            }
          ).then((result) => {
            dispatch(deleteDatCourseReset());
            
          })    
                
        }
      
    }, [props.deleteDatCourse])

    const [editLesson, setEditLesson] = useState("")

    console.log(editLesson)

    const handleEditLesson = (e,courseData) => {
        e.preventDefault()
        setEditLesson(courseData)
        
    } 

    const handleBackToDatCourses = (e) => {
        e.preventDefault()
        setEditLesson("")
    }

    const [searchCourse, setSearchCourse] = useState("");
    const [searchedCourse, setSearchedCourse] = useState([]);

    const searchCourses = async (value) => {
        let search = await arraySearch(datCoursesLists, value);
        setSearchedCourse(search);
        setSearchCourse(value);
    };
    const arraySearch = (array, keyword) => {
        console.log(array)
        const searchTerm = keyword.toLowerCase();
        return array.filter((value) => {
            return (
                value.courseDescription.toLowerCase().match(new RegExp(searchTerm, "g")) ||
                value.courseTitle.toLowerCase().match(new RegExp(searchTerm, "g")) ||
                value.instructorName.toLowerCase().match(new RegExp(searchTerm, "g"))
            );
        });
    };

      //Modal Behaviour
    const [modal, setModal] = useState(false);
    const modalToggle = () => setModal(!modal);
    const [backdrop, setBackdrop] = useState(true);

    const createBundleModal = () => {
        setBackdrop(true);
        setModal(true);
    }

    const [selectedCourse, setSelectedCourse] = useState([])
    const updateListOfItems = (e, index) => {
        
        const updatedList = [...courseLists];
        updatedList[index].checked = e.target.checked;
        setSelectedCourse(updatedList);
      
    }

    const [bundlePrice, setBundlePrice] = useState("")
    const [bundleTitle, setBundleTitle] = useState("")

    const handleBundlePriceChange = (event) => {
        setBundlePrice(event.target.value);
    };
    const handleBundleTitleChange = (event) => {
        setBundleTitle(event.target.value);
    };


    const createBundle = () =>{
        let bundleCourseIds = [];
        if(selectedCourse.length){
            selectedCourse.forEach(element => {
                if(element.checked === true){
                    bundleCourseIds.push(element.datCourseId)
                }
            });

        }

        let data = {
            price : bundlePrice,
            title: bundleTitle,
            courses: bundleCourseIds,
            userHandle: props.userDetails.handle
        }

        if(bundleCourseIds.length < 2){
            Swal.fire({
                title: "Select courses",
                text: "Select atleast 2 courses",
                type: "error"
            })
        }
        if(!bundleTitle || !bundlePrice){
            Swal.fire({
                title: "Fields Required",
                text: "Title and Price field are required",
                type: "error"
            })
        }
        if(bundleCourseIds.length >= 2 && bundleTitle &&  bundlePrice ){
            setModal(false)
            dispatch(createDatBundleCourses(data))
        }
        
    }


    useEffect(() => {
        if (props.createDatBundleCourses.loading) {
            Swal.fire({
                allowOutsideClick: false,
                didOpen: () => {
                Swal.showLoading();
                },
            });
        } else {
            if(props.createDatBundleCourses.bundlecourse.length){
                Swal.fire({
                    title: "Success!",
                    text: "Successfully created!",
                    icon: "success",
                    timer: 3000,
                }).then(() => {
                    dispatch(createDatBundleCoursesReset());
                    dispatch(fetchDatBundleCourses())
                    
                });
            }
           
        }
    }, [props.createDatBundleCourses]);



    return (
        <>
          <Header></Header>
        {
            editLesson ? 
            <>
              
                <Container className="mt--7" fluid>
                    <a href="" className="text-warning">
                    <Button className="shadow" color="info" onClick={(e) => handleBackToDatCourses(e)}><i className="fas fa-arrow-left"></i>&nbsp;&nbsp;Back to DAT Courses</Button></a>
                </Container> 
            </>
            
            : "" 
            
        }
        {
        Object.keys(editLesson).length === 0? <>
            <Container className="mt--7" fluid>
                {/* <TotalCourses  courses={datCoursesLists} payments={datCoursesSale} students={paidUsers} /> */}
                {/* <Row className="mt-4">
                   
                  
                </Row> */}
                <Row>
                    <Col lg="12 mt-3">
                        <Row>
                            <Col lg="8" md="8" sm="10" xs="10">
                                <FormGroup>
                                    <InputGroup className="mb-4">
                                        <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="fas fa-search" />
                                        </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Search.."
                                            type="text"
                                            value={searchCourse}
                                            onChange={(e) => searchCourses(e.target.value)}
                                            className='pl-1'
                                        />
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col lg="4" md="4" sm="2" xs="2">
                                <Button title="Add Course"  className="float-right d-none d-md-block d-lg-block form-control" color="success" onClick={toggleAddDatCourseModal} ><i className="fas fa-plus" /> Add Course </Button>
                                <Button title="Add Course" className="text-center rounded-circle d-sm-block d-lg-none d-xs-block d-md-none" color="success" onClick={toggleAddDatCourseModal} > <i className="fas fa-plus" /> </Button>
                            </Col>
                        </Row>
                        
                        {/* {   
                        searchCourse ? 
                                searchedCourse.length ? 
                                <>
                                    <>
                                    {
                                        searchedCourse.map((c, i) => {
                                            return ( <ManageCourseItem key={c.datCourseId} item={c} index={c.courseId} handleEditDetailsCallback={handleEditDetails} handlehandleEditCourseLessonsCallback={handleEditLesson} handleDeleteDetailsCallback={handleDeleteDetails} />)
                                        })
                                    }
                                    </>
                                    
                                    <div >
                                        {
                                        searchedCourse.length > coursesPerPage ?
                                            <div className="d-flex justify-content-center mt-3">
                                                <Paginate
                                                    itemPerPage={coursesPerPage}
                                                    totalItems={searchedCourse.length}
                                                    currentPage={currentPage}
                                                    paginate={paginate}
                                                    previousPage={previousPage}
                                                    nextPage={nextPage}
                                                />
                                            </div>
                                        : ""

                                        }
                                        
                                    </div>
                                </>   
                                : ("No Result")  
                            : 
                        
                        
                        !datCoursesLists.length ? 
                        
                                <Card className='shadow'>
                                    <CardBody className='text-center'>
                                        <h2 className='mb-0'>No courses listed.</h2>
                                    </CardBody>
                                </Card>
                        
                            :
                            currentCourses.map((c, i) => {
                                return (
                                    <ManageCourseItem key={c.datCourseId} item={c} index={c.courseId} handleEditDetailsCallback={handleEditDetails} handlehandleEditCourseLessonsCallback={handleEditLesson} handleDeleteDetailsCallback={handleDeleteDetails}/>
                                )
                            }) 
                        } */}

                    <Row>
                    <Col lg="12" md="12" className='mt-0'>
                    { 
                        searchCourse ? 
                            searchedCourse.length ? 
                            <Row>
                                
                                {
                                    searchedCourse.map((c, i) => {
                                        return (<Col xl="4" lg="6" md="12" sm="12" className="d-flex flex-column flex-wrap"><ManageCourseItem key={c.datCourseId} item={c} index={c.courseId} handleEditDetailsCallback={handleEditDetails} handlehandleEditCourseLessonsCallback={handleEditLesson} handleDeleteDetailsCallback={handleDeleteDetails} /></Col>)
                                    })
                                }
                                
                                
                                <Col xl="12" lg="12">
                                    {
                                    searchedCourse.length > coursesPerPage ?
                                        <div className="d-flex justify-content-center mt-3">
                                            <Paginate
                                                itemPerPage={coursesPerPage}
                                                totalItems={searchedCourse.length}
                                                currentPage={currentPage}
                                                paginate={paginate}
                                                previousPage={previousPage}
                                                nextPage={nextPage}
                                            />
                                        </div>
                                    : ""

                                    }
                                    
                                </Col>
                            </Row>

                                
                                
                            : <p className='text-center font-weight-bolder text-dark'>No Result</p>
                        : 
                         <>
                        
                            { !datCoursesLists.length ? 
                                <Card className='shadow'>
                                    <CardBody className='text-center'>
                                        <h2 className='mb-0'>No courses listed.</h2>
                                    </CardBody>
                                </Card>
                                :
                                <Row>   
                                    {

                                        currentCourses.map((c, i) => (
                                        
                                            <Col xl="4" lg="6" md="12" sm="12" className="d-flex flex-column flex-wrap"><ManageCourseItem key={c.datCourseId} item={c} index={c.courseId} handleEditDetailsCallback={handleEditDetails} handlehandleEditCourseLessonsCallback={handleEditLesson} handleDeleteDetailsCallback={handleDeleteDetails}/></Col>
                                            
                                            
                                        ))
                                    }
                                    <Col xl="12" lg="12">
                                    {
                                        datCoursesLists.length > coursesPerPage ?
                                        <div className="d-flex justify-content-center mt-3">
                                            <Paginate
                                                itemPerPage={coursesPerPage}
                                                totalItems={datCoursesLists.length}
                                                currentPage={currentPage}
                                                paginate={paginate}
                                                previousPage={previousPage}
                                                nextPage={nextPage}
                                            />
                                        </div>
                                        :""
                                    }
                                    </Col>
                                </Row>
                            } 
                       
                      
                        

                        </>
                        }
                        </Col>
                        </Row>
                    </Col>
                    {/* <Col lg="4">
                        <Card className="shadow-lg rounded mb-2">
                            <CardBody className="">
                                <Row>
                                    <Col lg="12">
                                        <CardTitle tag="h3">
                                            Bundle Courses
                                            <Button title="Add a Bundle" size="sm" className="float-right" color="info"  onClick={createBundleModal}> Create Bundle</Button>
                                        </CardTitle>
                                    </Col>
                                </Row>
                               
                                <div className="mt-3">
                                   {
                                    bundleCourses.length ?
                                    bundleCourses.map((c,i)=>(
                                        <Card className="shadow mb-1" role="button">
                                            <CardBody className="position-relative">
                                                <CardTitle>
                                                    <h5>{i+1}. {c.title}  
                                                        <Badge
                                                            color="success"
                                                            size="sm"
                                                            className="rounded-pill float-right"
                                                            >
                                                            ${addZeroes(Number(c.price))}
                                                        </Badge>
                                                    </h5>
                                                   
                                                </CardTitle>
                                                <Row className="justify-content-center">
                                                   
                                                    {
                                                        c.courseItems.length ? 
                                                            c.courseItems.map((course,i)=>(
                                                               <Card className="col-lg-5 col-md-5 col-sm-5  p-0 m-1" >
                                                                
                                                                    {course.courseThumbnail != "" ? 
                                                                    
                                                                        <CardImg
                                                                            alt="..."
                                                                            src={`https://storage.googleapis.com/datdashboard.appspot.com/img-dat-courses/` + course.courseThumbnail+``}
                                                                            
                                                                            top
                                                                            style={{height : "100%", objectFit: "fill", width:"100%"}}
                                                                        />
                                                                        
                                                                        :

                                                                        <CardImg
                                                                            alt="..."
                                                                        
                                                                            src={require("assets/img/brand/no-image.jpg")}
                                                                            top
                                                                             style={{height : "100%", objectFit: "fill", width:"100%"}}
                                                                        />
                                                                    }

                                                                    
                                                                    <small className="text-truncate">{course.courseTitle}</small>
                                                                    

                                                                   
                                                                </Card>
                                                               
                                                               
                                                            ))
                                                        : ""
                                                    }
                                                </Row>
                                                <Badge  
                                                    style={{position: "absolute",zIndex:"9",left:"46%",top:"53%"}}
                                                    color="primary"   
                                                    size="sm"
                                                    className="rounded-pill fill"
                                                    >
                                                    <i className="fa fa-plus"></i>
                                                </Badge>
                                            </CardBody>
                                        </Card>

                                    ))
                                    : 
                                    ""
                                   }
                                </div>

                            </CardBody>
                        </Card>
                    </Col> */}
                </Row>
                <Row >
                    {
                    datCoursesLists.length > coursesPerPage
                        ?
                        <Col md="12" className="d-flex justify-content-center mt-3">
                            <Paginate
                                itemPerPage={coursesPerPage}
                                totalItems={datCoursesLists.length}
                                currentPage={currentPage}
                                paginate={paginate}
                                previousPage={previousPage}
                                nextPage={nextPage}
                            />

                        </Col>
                        :""
                    }
                   
                   
                </Row>
                   
               
            </Container>
            </>
            : <Container className="mt-3" fluid><ManageDatCoursesLessons courseData={editLesson}></ManageDatCoursesLessons></Container>}
            <AddDatCourseModal modalAddDatCourseModal={modalAddDatCourseModal} toggleAddDatCourseModal={toggleAddDatCourseModal} editCourse={editCourse} coursesData={props.fetchDatCourses} />
            
            <Modal
                isOpen={modal}
                toggle={modalToggle}
                backdrop={backdrop}
                size="xl"
                style={{width: '100%'}}
         
            >
            <ModalHeader toggle={modalToggle}>
                Create A Bundle Course
            </ModalHeader>
                <ModalBody className=""  >
                    <Row>
                        <Col lg="6">
                            {
                                courseLists.length ? 
                                // console.log(datCoursesLists)
                                courseLists.map((course,index)=>(
                                
                                    <Card className="shadow-lg rounded mb-3 position-relative" key={index} >
                                        <FormGroup check style={ { position: 'absolute', zIndex:'999'}}>
                                            <Label check>
                                                <Input style={ { top: 0 }} key={course.datCourseId} type="checkbox"  name={"select-"+course.datCourseId} id={"select-"+course.datCourseId}  onChange={(e) => updateListOfItems(e,index)} />{' '}
                                            </Label>
                                        </FormGroup>
                                     
                                        <CardBody className="p-0 ">
                                            <Row>
                                                <Col lg="6" className="m-0 p-0">
                                                    {course.courseThumbnail != "" ? 
                                                    
                                                        <CardImg
                                                            alt="..."
                                                            src={`https://storage.googleapis.com/pre-dental-tracker.appspot.com/img-dat-courses/` + course.courseThumbnail+``}
                                                            
                                                            top
                                                            style={{height : "100%", objectFit: "fill", width:"100%"}}
                                                        />
                                                        
                                                        :

                                                        <CardImg
                                                            alt="..."
                                                        
                                                            src={require("assets/img/brand/no-image.jpg")}
                                                            top
                                                            style={{height : "100%", objectFit: "fill", width:"100%"}}
                                                        />
                                                    }
                                                </Col>
                                                <Col lg="6" className=" d-flex flex-column flex-wrap">
                                                    <div className="mb-auto py-2 px-2">
                                                        <h5 role="button" >{course.courseTitle}</h5>
                                                    </div>
                                                    <div className="mb-1 px-2">
                                                        <Button
                                                            color="primary"
                                                            size="sm"
                                                            className="rounded-pill"
                                                            >
                                                            ${addZeroes(Number(course.coursePrice))}
                                                        </Button>
                                                    
                                                        <div className="mt-2 mb-1 ">
                                                            <Badge color={course.visibility == "published" ? "info" : "danger"} className="mr-3">{course.visibility}</Badge>
                                                           
                                                        </div>
                                                        
                                                    </div>
                                                    
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                ))

                                : ""
                            }

                        </Col>
                        <Col lg="6">

                            <Row className="mb-3">
                                {
                                    selectedCourse.length ?
                                        selectedCourse.map((c,i) =>(
                                            c.checked === true ?
                                            <Col lg="6">
                                                <Card key={c.datCourseId}  >
                                                    {c.courseThumbnail != "" ? 
                                                            
                                                        <CardImg
                                                            alt="..."
                                                            src={`https://storage.googleapis.com/pre-dental-tracker.appspot.com/img-dat-courses/` + c.courseThumbnail+``}
                                                            width="100%"
                                                            top
                                                           
                                                        />
                                                        
                                                        :

                                                        <CardImg
                                                            alt="..."
                                                             width="100%"
                                                            src={require("assets/img/brand/no-image.jpg")}
                                                            top
                                                           
                                                        />
                                                    }
                                                     <CardBody className="p-2">
                                                        <CardTitle tag="h6">{c.courseTitle}</CardTitle>
                                                        <Badge
                                                            color="success"
                                                            size="sm"
                                                            className="rounded-pill"
                                                            >
                                                            ${addZeroes(Number(c.coursePrice))}
                                                        </Badge>
                                                     </CardBody>

                                                </Card>
                                            </Col>
                                            : ""
                                        ))
                                    : ""
                                }
                           
                            </Row>
                            <Row>
                                <Form className="col-md-12">
                                    <FormGroup>
                                        <Label for="bundleprice">Price</Label>
                                        <Input size="sm" value={bundlePrice} type="number" name="bundleprice" id="bundleprice" placeholder="" onChange={handleBundlePriceChange}/>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="bundletitle">Title</Label>
                                        <Input size="sm" value={bundleTitle} type="text" name="bundletitle" id="bundletitle" placeholder="" onChange={handleBundleTitleChange}/>
                                    </FormGroup>
                                
                                </Form>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <div className="float-right">
                                        <Button size="" color="secondary" onClick={modalToggle}>Cancel</Button>
                                        <Button size="" color="primary" onClick={createBundle}>Save</Button>{' '}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        
        </>
    )
}

const mapStateToProps = state  => {
    return {
        userDetails : state.loginAuth.userDetails,
        fetchDatCourses : state.fetchDatCourses,
        createDatCourse : state.createDatCourse,
        updateDatCourse : state.updateDatCourse,
        deleteDatCourse : state.deleteDatCourse,
        fetchPaymentRecord: state.fetchPaymentRecord,
        createDatBundleCourses: state.createDatBundleCourses,
        fetchDatBundleCourses :state.fetchDatBundleCourses,
        
    }
      
}

export default connect(mapStateToProps)(ManageDatCourses)
